import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useMemo, useRef } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Checkbox from "@mui/material/Checkbox";
import { TextField } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
export const HomeNrpFilter = ({
  nrpList,
  selectedNrpsAux,
  setSelectedNrpsAux,
  selectAllItem,
}) => {
  const [selectedNrps, setSelectedNrps] = useState([]);

  const refreshTimeOut = useRef(0);

  const nrpListWithToggle = useMemo(() => {
    return nrpList.length > 0 ? [selectAllItem, ...nrpList] : [];
  }, [nrpList]);

  const { t } = useTranslation();

  /**
   * Selecciona por defecto todos los NRPs
   */
  useEffect(() => {
    setSelectedNrps(nrpListWithToggle);
  }, [nrpList]);

  /**
   * filterOptions para el autocomplete de compañías
   */
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 200,
  });

  /**
   *
   * Maneja toda la lógica de selección de opciones del autocomplete de NRPs
   *
   * @param {Event} event
   * @param {Array} values
   * @param {String} reason tipo de selección; selectOption, removeOption
   * @param {Object} detail opción elegida
   */
  const onNrpsChange = (event, values, reason, detail) => {
    const option = detail?.option ?? null;
    values = values.filter((item) => item.value !== selectAllItem.value);

    if (reason === "removeOption" && option?.value === selectAllItem.value) {
      values = [];
    } else if (
      reason === "selectOption" &&
      option?.value === selectAllItem.value
    ) {
      values = nrpList;
    }

    const newSelectedNrps =
      values.length === nrpList.length ? [...values, selectAllItem] : values;

    // Refresh after 3s
    clearTimeout(refreshTimeOut.current);
    refreshTimeOut.current = setTimeout(async () => {
      const listsAreEqual = (a, b) => {
        const sizeCondition = a.length === b.length;
        const compareCondition =
          a.filter((i) => b.includes(i)).length === a.length;

        return sizeCondition && compareCondition;
      };

      const newSelectedNrpsSimple = newSelectedNrps
        .filter((opt) => opt.value !== selectAllItem.value)
        .map((opt) => opt.value);

      if (!listsAreEqual(newSelectedNrpsSimple, selectedNrpsAux)) {
        setSelectedNrpsAux(newSelectedNrpsSimple);
      }
    }, 3000);

    setSelectedNrps(newSelectedNrps);
  };

  return (
    <Autocomplete
      noOptionsText={t("App.validationMessages.noMatchFilter")}
      className="select__filters__large--keep-width"
      multiple
      isOptionEqualToValue={(option, value) => option.value === value.value}
      filterOptions={filterOptions}
      value={selectedNrps}
      options={nrpListWithToggle}
      disableCloseOnSelect
      limitTags={1}
      onChange={(event, values, reason, detail) => {
        onNrpsChange(event, values, reason, detail);
      }}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option, { selected }) => (
        <li key={option.label} {...props}>
          <Checkbox
            icon={icon}
            className="autoComplete__checkbox"
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.label}
        </li>
      )}
      renderTags={(values) => {
        const size = values.filter(
          (item) => item.value !== selectAllItem.value
        ).length;
        const label =
          size > 1
            ? t("App.autocomplete.selected")
            : t("App.autocomplete.oneSelected");

        return (
          <Chip
            label={`${size} ${label}`}
            className="autocomplete-chip"
            variant="filled"
          />
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("App.infonavitDashboard.client.selectPlaceholder")}
        />
      )}
    />
  );
};
